<template>
  <div>
    <v-menu v-if="canUseConversationActions" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :loading="loading.action"
          v-bind="attrs"
          v-on="on"
          depressed
          class="mr-1"
          icon
        >
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <!-- Join conversation -->
        <template v-if="canOpenConversation && !isParticipant">
          <v-list-item class="px-3" @click="$emit('join')">
            <v-list-item-icon class="mr-0">
              <v-icon small> mdi-location-enter </v-icon>
            </v-list-item-icon>

            <v-list-item-title>
              {{ $t("chat.form.join.title") }}
            </v-list-item-title>
          </v-list-item>

          <v-divider />
        </template>

        <!-- Refresh messages -->
        <v-list-item
          v-if="canGetMessages"
          class="px-3"
          @click="$emit('refresh')"
        >
          <v-list-item-icon class="mr-0">
            <v-icon small> mdi-email-sync-outline </v-icon>
          </v-list-item-icon>

          <v-list-item-title>
            {{ $t("chat.messages.btn_refresh") }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- Ticket -->
    <v-menu
      v-if="canCreateTicket"
      offset-x
      :nudge-left="30"
      :nudge-width="190"
      :close-on-content-click="false"
      bottom
      left
    >
      <template v-slot:activator="menu">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              target="_blank"
              v-bind="{ ...attrs, ...menu.attrs }"
              v-on="{ ...on, ...menu.on }"
            >
              <v-icon>mdi-ticket-outline</v-icon>
            </v-btn>
          </template>

          <span>
            {{ $t("chat.btn.ticket.help") }}
          </span>
        </v-tooltip>
      </template>

      <v-list dense>
        <v-list-item class="px-3">
          <v-list-item-content class="d-flex flex-column align-start">
            <v-select
              v-model="localForm.formsId"
              :label="$t('chat.fields.formsId.title')"
              :placeholder="$t('chat.fields.formsId.placeholder')"
              :items="forms"
              item-text="name"
              item-value="id"
              :loading="loading.forms"
              style="min-width: 100%"
            />

            <v-text-field
              v-model="localForm.contactId"
              :label="$t('chat.fields.contactId.title')"
              :placeholder="$t('chat.fields.contactId.placeholder')"
              style="min-width: 100%"
            />

            <div>
              <v-btn
                color="primary"
                :disabled="!localForm.formsId"
                small
                depressed
                target="_blank"
                :to="ticketRoute"
              >
                {{ $t("btn.access") }}
              </v-btn>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "ConversationActions",

  props: {
    conversation: {
      type: Object,
      default: null,
    },

    loading: {
      type: Object,
      default: () => ({
        action: false,
        forms: false,
      }),
    },

    forms: {
      type: Array,
      default: () => [],
    },

    form: {
      type: Object,
      required: true,
    },

    isParticipant: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    localForm: {
      get() {
        return this.form;
      },

      set(value) {
        this.$emit("update:form", value);
      },
    },

    canOpenConversation() {
      return this.$permission.$can("conversation.open", ["user", "service"]);
    },

    canGetMessages() {
      return this.$permission.$can("message.get", ["user", "service"]);
    },

    canCreateTicket() {
      return this.$permission.$can("ticket.create", ["user", "service"]);
    },

    canUseConversationActions() {
      return this.canOpenConversation || this.canGetMessages;
    },

    ticketRoute() {
      if (!this.conversation) {
        return {
          name: "tickets",
        };
      }

      return {
        name: "tickets",
        query: {
          form: this.localForm.formsId,
          service: this.conversation.channel.service.id,
          channel: this.conversation.channel.type,
          contact: this.localForm.contactId,
        },
      };
    },
  },
};
</script>
